"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = require("@emotion/react");
var makeThankYouBannerStyling = function () {
    var mvf = (0, react_1.useTheme)().mvf;
    var spacing = mvf.spacing, palette = mvf.palette, filters = mvf.filters;
    return {
        brandLogo: (0, react_1.css)({
            height: 50,
            marginBottom: spacing.small,
            marginTop: spacing.small,
        }),
        thankYouBanner: (0, react_1.css)({
            backgroundColor: (0, material_1.lighten)(palette.component.answerSelectedColor, filters.lighten.harsh),
            padding: '0 10% 20px 10%',
            textAlign: 'center',
            '& h6, p': {
                marginBottom: 15,
            },
        }),
    };
};
exports.default = makeThankYouBannerStyling;
//# sourceMappingURL=makeThankYouBannerStyling.js.map